export enum PromptKey {
  JDExtractor = 'jd_extractor',
  JDRequirements = 'jd_requirements',

  ResumeExtractor = 'resume_extractor',
  ResumeAnalyzer = 'resume_analyzer',

  ResumeJobPositionFit = 'resume_job_position_fit',
  JobResumeMatching = 'job_resume_matching',

  InterviewAnalyzer = 'interview_analyzer',
  InterviewGenerator = 'interview_generator',

  ScreeningAnalyzerJobInterview = 'screening_analyzer_job_interview',
  ScreeningGeneratorJobInterview = 'screening_generator_job_interview',

  ScreeningAnalyzerResumeScreening = 'screening_analyzer_resume_screening',
  ScreeningGeneratorResumeScreening = 'screening_generator_resume_screening',

  OverviewAnalyzer = 'overview_analyzer',

  QuestionBankExtractor = 'question_bank_extractor',

  VeteransResumeExtractor = 'veterans_resume_extractor',
  VeteransResumeGenerator = 'veterans_resume_generator',

  EmbeddingVector = 'embedding_vector',
  MilitaryTranslationSample = 'military_translation_sample'
}

export function getPromptKeyLabel(promptKey: PromptKey): string {
  switch (promptKey) {
    case PromptKey.JDExtractor:
      return 'JD Extractor';
    case PromptKey.JDRequirements:
      return 'JD Requirements';
    case PromptKey.ResumeExtractor:
      return 'Resume Extractor';
    case PromptKey.ResumeJobPositionFit:
      return 'Resume Fit';
    case PromptKey.ResumeAnalyzer:
      return 'Resume Analysis';
    case PromptKey.InterviewAnalyzer:
      return 'Interview Analysis';
    case PromptKey.ScreeningAnalyzerJobInterview:
      return 'Screening Analysis (Job Interview)';
    case PromptKey.ScreeningAnalyzerResumeScreening:
      return 'Screening Analysis (Resume Screening)';
    case PromptKey.OverviewAnalyzer:
      return 'Overview Analysis';
    case PromptKey.InterviewGenerator:
      return 'Interview Generator';
    case PromptKey.JobResumeMatching:
      return 'Job Resume Matching';
    case PromptKey.ScreeningGeneratorJobInterview:
      return 'Screening Generator (Job Interview)';
    case PromptKey.ScreeningGeneratorResumeScreening:
      return 'Screening Generator (Resume Screening)';
    case PromptKey.QuestionBankExtractor:
      return 'Question Bank Extractor';
    case PromptKey.VeteransResumeExtractor:
      return 'Veterans Resume Extractor';
    case PromptKey.VeteransResumeGenerator:
      return 'Veterans Resume Generator';
    case PromptKey.EmbeddingVector:
      return 'Embedding Vector';
    case PromptKey.MilitaryTranslationSample:
      return 'Military Translation Sample';
    default:
      return 'Unknown';
  }
}

export function getAllPromptKeys(): PromptKey[] {
  return Object.values(PromptKey);
}
